import { atsRequest } from "../../configs/axios.config";

class FilesCategoriesService {
    allFilesCategories(success,error) {
        return atsRequest
          .get('/api/v1/files_categories?applicant_id=')
          .then(({data}) => success(data))
          .catch((errorResp) => error(errorResp));
    }

    createNewFileCategory(data,success,error) {
        return atsRequest
            .post('/api/v1/files_categories',data)
            .then(({data}) => success(data))
            .catch((errorResp) => error(errorResp));
    }

    editFileCategory(data,success,error) {
        return atsRequest
            .put(`/api/v1/files_categories/${data.id}`,data)
            .then(({data}) => success(data))
            .catch((errorResp) => error(errorResp));
    }

    deleteFileCategory(data,success,error) {
        return atsRequest
            .delete(`/api/v1/files_categories/${data}`)
            .then(({data}) => success(data))
            .catch((errorResp) => error(errorResp));
    }
}

export const filesCategoriesService = new FilesCategoriesService()